import { ReactNode, useEffect, useState } from "react";

/**
 * Defers mounting its children until the browser is idle.
 *
 * Used to keep below-the-fold widgets out of the initial JS execution
 * path so Speed Index / TTI stay low. Initial SSR and hydration both render
 * null, preventing mobile-only hydration mismatches / blank frames.
 */
export function DeferUntilIdle({
  children,
  timeout = 1500,
}: {
  children: ReactNode;
  timeout?: number;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    const w = window as any;
    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(() => setReady(true), { timeout });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = window.setTimeout(() => setReady(true), 200);
    return () => window.clearTimeout(t);
  }, [ready, timeout]);

  if (!ready) return null;
  return <>{children}</>;
}
